<template>
    <div class="mx-2">
        <Menu
            :items="organizedItems"
            :groupProperty="group_property"
            ulClass="nav nav-sidebar flex-column"
        />
    </div>
</template>

<script>
import { CheckPermission } from '../../mixins/acls';
import { findItemNested } from '@config/utils';
import { MENU } from '@/app/shared/utils/constants';

export default {
    mixins: [
        CheckPermission
    ],
    components: {
        Menu: () => import(/* webpackChunkName: "gestaomenu-menu" */ './elements/Menu'),
    },
    props: {
        moduleCode: {
            required: true,
            type: String
        },
        groups: {
            type: Array,
            default: null
        },
        items: {
            type: Array,
            default: null
        }
    },
    data () {
        return {
            group_property: MENU.GROUP_PROPERTY,
        }
    },
    computed: {
        currentRouteName() {
            return this.$route.name.replace(/.create|.edit|.show/gi, '');
        },
        menuGroups(){
            return this.groups === null ? this.$store.getters.getGroupsMainMenu(this.moduleCode) : this.groups;
        },
        activeMenuGroups(){
            return this.filterItems(this.menuGroups, x => (x.active || x.active ==undefined) && this.checkPermission(x, 'auth'));
        },
        menuItems(){
            return this.items === null ? this.$store.getters.getMainMenu(this.moduleCode) : this.items;
        },
        activeMenuItems(){
            return this.menuItems.filter(item => (item.active || item.active ==undefined) && this.checkPermission(item, 'auth'));
        },
        organizedItems(){
            const groups = this.activeMenuGroups;
            const organizedItems = [];
            let currentItem = null;

            this.activeMenuItems
            .sort((a, b) => a.group ? 1 : 0)
            .forEach(item => {
                let isCurrentItem = false;
                if(!currentItem && item?.route == this.currentRouteName) {
                    currentItem = item;
                    isCurrentItem = true;
                }
                let group = item?.group ?? null;
                if(group){
                    let _group = findItemNested(groups, x => x.code == group && x[this.group_property], 'items');
                    if(!_group) {
                        _group = {code: group};
                        groups.push(_group);
                    }

                    if(!_group.items) {
                        _group.items = [];
                    }
                    // group.items = [];
                    // let _group = groups.find(x => x?.code == group?.code);
                    // if(!_group) {
                        //     _group = {...group}
                    //     groups.push(_group);
                    // }

                    _group.open = isCurrentItem ? true : (_group?.open ?? false);
                    if(!_group.items.find(x => x.route == item.route)) {
                        _group.items.push(item);
                    }
                }else{
                    if(!organizedItems.find(x => x.route == item.route)) {
                        item.order = item?.order ?? 1;//-1 * (item?.order ?? 1);
                        organizedItems.push(item);
                    }

                }
            });

            return [...organizedItems, ...groups].sort((a, b) => a.order - b.order);
        },
    },
    methods: {
        filterItems(arr, fn) {
            let matches = [];
            if (!Array.isArray(arr)) return matches;

            arr.forEach((item) => {
                if(item.items) {
                    item.items = this.filterItems(item.items, fn);
                }
                if (fn(item)) {
                    if(item.open == undefined) {
                        this.$set(item, 'open', false);
                    }
                    if(item.order == undefined) {
                        this.$set(item, 'order', 1);
                    }
                    matches.push(item);
                }
            });
            return matches;
        },
    },
    watch: {
    }
}
</script>
